import '../../Detail.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, jsx } from "react/jsx-runtime";
import "../../Utilities.js";
import { getId } from "@fluentui/react/lib/Utilities";
import "../Label/index.js";
import "../Stack.js";
import { Stack } from "../Stack/Stack.js";
import { css } from "@fluentui/utilities";
import { Label } from "../Label/Label.js";
const Detail$1 = "";
const defaultClassName = "ane-Detail";
const Detail = (_a) => {
  var _b = _a, { className, label = "", value, labelProps = {}, children } = _b, rest = __objRest(_b, ["className", "label", "value", "labelProps", "children"]);
  const id = getId("ane-Detail-");
  const defaultAriaLabel = typeof children === "string" ? children : typeof label === "string" ? label : "";
  const { htmlFor = id, className: labelClassName, iconProps } = labelProps;
  const { styles: iconStyles } = iconProps || {};
  const defaultIconProps = __spreadProps(__spreadValues({
    iconName: "Info",
    ariaLabel: ""
  }, iconProps), {
    styles: __spreadProps(__spreadValues({}, iconStyles), {
      root: {
        paddingTop: "0px",
        paddingRight: "4px",
        paddingBottom: "0px",
        paddingLeft: "4px",
        width: "24px",
        height: "14px",
        textAlign: "center",
        verticalAlign: "middle",
        lineHeight: "14px",
        boxSizing: "border-box"
      }
    })
  });
  return /* @__PURE__ */ jsxs(Stack, __spreadProps(__spreadValues({}, rest), { className: css(defaultClassName, className), "aria-label": defaultAriaLabel, children: [
    /* @__PURE__ */ jsx(
      Label,
      __spreadProps(__spreadValues({
        title: typeof label === "string" ? label : ""
      }, labelProps), {
        iconProps: defaultIconProps,
        htmlFor,
        className: css(labelClassName, `${defaultClassName}-label`),
        children: label
      })
    ),
    /* @__PURE__ */ jsx("span", { id, className: `${defaultClassName}-value`, children: value || children })
  ] }));
};
export {
  Detail,
  Detail as default
};
//# sourceMappingURL=Detail.js.map
